import React, { useState } from 'react';
import { LegalModal } from './LegalModal';
export function Footer() {
  const [privacyOpen, setPrivacyOpen] = useState(false);
  const [termsOpen, setTermsOpen] = useState(false);
  return <>
      <footer className="bg-bakery-brown py-8 px-6" data-id="element-35">
        <div className="max-w-4xl mx-auto flex flex-col items-center space-y-4" data-id="element-36">
          <div className="flex items-center space-x-6" data-id="element-37">
            <button onClick={() => setPrivacyOpen(true)} className="text-bakery-tan/70 hover:text-bakery-amber transition-colors text-sm" data-id="element-38">
              Política de Privacidad
            </button>
            <span className="text-bakery-tan/30" data-id="element-39">|</span>
            <button onClick={() => setTermsOpen(true)} className="text-bakery-tan/70 hover:text-bakery-amber transition-colors text-sm" data-id="element-40">
              Términos y Condiciones
            </button>
          </div>
          <p className="text-bakery-tan/40 text-xs" data-id="element-41">
            © {new Date().getFullYear()} Manual del Pan: Cero Errores. Todos
            los derechos reservados.
          </p>
        </div>
      </footer>

      <LegalModal isOpen={privacyOpen} onClose={() => setPrivacyOpen(false)} title="Política de Privacidad" data-id="element-42">
        <p className="font-semibold text-bakery-brown" data-id="element-43">
          Última actualización: Marzo 2026
        </p>
        <p data-id="element-44">
          Tu privacidad es importante para nosotros. Esta política describe cómo
          recopilamos, usamos y protegemos tu información personal cuando
          utilizas nuestro sitio web y adquieres nuestros productos digitales.
        </p>
        <h3 className="font-serif font-bold text-lg text-bakery-brown pt-2" data-id="element-45">
          Información que Recopilamos
        </h3>
        <p data-id="element-46">
          Recopilamos información que nos proporcionas directamente al realizar
          una compra, como tu nombre, dirección de correo electrónico y datos de
          pago. Los datos de pago son procesados de forma segura por nuestro
          proveedor de pagos y no almacenamos información de tarjetas de crédito
          en nuestros servidores.
        </p>
        <h3 className="font-serif font-bold text-lg text-bakery-brown pt-2" data-id="element-47">
          Uso de la Información
        </h3>
        <p data-id="element-48">
          Utilizamos tu información para procesar tu compra, enviarte el
          producto digital adquirido, y comunicarnos contigo sobre tu pedido. No
          vendemos, alquilamos ni compartimos tu información personal con
          terceros con fines de marketing.
        </p>
        <h3 className="font-serif font-bold text-lg text-bakery-brown pt-2" data-id="element-49">
          Cookies
        </h3>
        <p data-id="element-50">
          Nuestro sitio puede utilizar cookies para mejorar tu experiencia de
          navegación y analizar el tráfico del sitio. Puedes configurar tu
          navegador para rechazar cookies, aunque esto puede afectar algunas
          funcionalidades.
        </p>
        <h3 className="font-serif font-bold text-lg text-bakery-brown pt-2" data-id="element-51">
          Seguridad
        </h3>
        <p data-id="element-52">
          Implementamos medidas de seguridad razonables para proteger tu
          información personal contra acceso no autorizado, alteración o
          destrucción.
        </p>
        <h3 className="font-serif font-bold text-lg text-bakery-brown pt-2" data-id="element-53">
          Cambios a esta Política
        </h3>
        <p data-id="element-54">
          Nos reservamos el derecho de actualizar esta política en cualquier
          momento. Los cambios serán publicados en esta página con la fecha de
          actualización correspondiente.
        </p>
      </LegalModal>

      <LegalModal isOpen={termsOpen} onClose={() => setTermsOpen(false)} title="Términos y Condiciones" data-id="element-55">
        <p className="font-semibold text-bakery-brown" data-id="element-56">
          Última actualización: Marzo 2026
        </p>
        <p data-id="element-57">
          Al acceder y utilizar este sitio web y adquirir nuestros productos
          digitales, aceptas cumplir con los siguientes términos y condiciones.
        </p>
        <h3 className="font-serif font-bold text-lg text-bakery-brown pt-2" data-id="element-58">
          Productos Digitales
        </h3>
        <p data-id="element-59">
          El "Manual del Pan: Cero Errores" es un producto digital descargable.
          Una vez completada la compra, recibirás acceso inmediato al contenido.
          Debido a la naturaleza digital del producto, todas las ventas son
          finales.
        </p>
        <h3 className="font-serif font-bold text-lg text-bakery-brown pt-2" data-id="element-60">
          Propiedad Intelectual
        </h3>
        <p data-id="element-61">
          Todo el contenido del manual, incluyendo textos, recetas, fotografías
          e ilustraciones, está protegido por derechos de autor. La compra del
          manual te otorga una licencia personal e intransferible para uso
          privado. Queda prohibida la reproducción, distribución o reventa del
          contenido sin autorización expresa.
        </p>
        <h3 className="font-serif font-bold text-lg text-bakery-brown pt-2" data-id="element-62">
          Uso del Producto
        </h3>
        <p data-id="element-63">
          Las recetas e instrucciones proporcionadas son para uso personal y
          doméstico. Los resultados pueden variar según los ingredientes,
          equipos y condiciones individuales. No garantizamos resultados
          específicos.
        </p>
        <h3 className="font-serif font-bold text-lg text-bakery-brown pt-2" data-id="element-64">
          Limitación de Responsabilidad
        </h3>
        <p data-id="element-65">
          No nos hacemos responsables por daños directos o indirectos que puedan
          surgir del uso de nuestro producto. El uso del manual y sus recetas es
          bajo tu propia responsabilidad.
        </p>
        <h3 className="font-serif font-bold text-lg text-bakery-brown pt-2" data-id="element-66">
          Modificaciones
        </h3>
        <p data-id="element-67">
          Nos reservamos el derecho de modificar estos términos en cualquier
          momento. Las modificaciones entrarán en vigor inmediatamente después
          de su publicación en el sitio web.
        </p>
      </LegalModal>
    </>;
}